/**
 * @param {import('./FSEntry.js').FSFileEntry | Blob} f 
 * @returns {Promise<ArrayBuffer>}
 */
export const readAsArrayBuffer = async f => readAs(f, 'readAsArrayBuffer')
/**
 * @param {import('./FSEntry.js').FSFileEntry | Blob} f 
 * @returns {Promise<string>}
 */
export const readAsBinaryString = async f => readAs(f, 'readAsBinaryString')
/**
 * @param {import('./FSEntry.js').FSFileEntry | Blob} f 
 * @returns {Promise<string>}
 */
export const readAsDataURL = async f => readAs(f, 'readAsDataURL')
/**
 * @param {import('./FSEntry.js').FSFileEntry | Blob} f 
 * @returns {Promise<string>}
 */
export const readAsText = async f => readAs(f, 'readAsText')

/**
 * 
 * @param {import("./FSEntry").FSFileEntry | Blob} f 
 * @param {string} as 
 * @returns 
 */
const readAs = async (f, as) => {
  // Handle file system access API files
  if ('handle' in f) {
    try {
      const tmp = await f.handle.getFile()
      f.lastModified = tmp.lastModified
      f.size = tmp.size
      f = tmp
    } catch (e) {
      console.warn(as, f)
      throw e
    }
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    // L3 fix: Clear handlers after completion to help garbage collection
    reader.onload = event => {
      reader.onload = null
      reader.onerror = null
      resolve(event.target?.result)
    }
    reader.onerror = error => {
      reader.onload = null
      reader.onerror = null
      const msg = 'error reading ' + f.name
      console.error(msg, f, error)
      reject(new Error(msg))
    }
    reader[as](f)
  })
}
